import { BrandTile } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function BrandTileDemo() {
  return (
    <Section
      id="brand-tile"
      title="BrandTile"
      description="The brand anchor tile — a steel-toned, card-scale (nx-s) hex-notch surface holding the AikoMark glyph. Used as the Office rail header brand anchor. The notch silhouette draws elevation as a clip-safe .elev-card drop-shadow and the outline as a continuous nx-rim keyline ring, never a box-shadow or border that the clip-path would slice. Honors prefers-reduced-motion (resting frame) automatically."
    >
      <VariantBlock label="Default" caption="46px steel tile, breathing mark, nx-s notch + keyline">
        <BrandTile />
      </VariantBlock>

      <VariantBlock label="Sizes" caption="size prop drives the notched container + the mark">
        <div className="flex flex-wrap items-end gap-4">
          <BrandTile size={32} />
          <BrandTile size={46} />
          <BrandTile size={64} />
          <BrandTile size={88} />
        </div>
      </VariantBlock>

      <VariantBlock label="Resting" caption="animated={false} — the static resting frame (eyes open, no breath)">
        <BrandTile animated={false} />
      </VariantBlock>

      <VariantBlock label="On a dark panel" caption="the steel gradient + nx-rim keyline read against a darker backdrop">
        <div className="flex items-center gap-4 rounded-lg bg-foreground/90 p-6">
          <BrandTile size={56} />
          <span className="text-sm font-medium text-background">The Office</span>
        </div>
      </VariantBlock>
    </Section>
  );
}
